import React from 'react';
import DropdownGeneral from '../DropdownGeneral/DropdownGeneral';
import { DropdownAnomalyRatingProps } from './DropdownAnomalyRating.type';
const list = [
  {
    value: 'all',
    label: 'All Rating'
  },
  {
    value: '1',
    label: '1 - Sighting'
  },
  {
    value: '2',
    label: '2 - Encounter'
  },
  {
    value: '3',
    label: '3 - Confrontation'
  },
  {
    value: '4',
    label: '4 - Skirmish'
  },
  {
    value: '5',
    label: '5 - Rift Incursion'
  },
  {
    value: '6',
    label: '6 - Mythic Outbreak'
  },
  {
    value: '7',
    label: '7 - Mythic Invasion'
  }
];
const DropdownAnomalyRating: React.FC<DropdownAnomalyRatingProps> = ({
  defaultValue,
  onChange,
  disabled = false
}) => {
  return (
    <DropdownGeneral
      data-testid="dropdown-anomaly-rating"
      placeholder="Anomaly Rating"
      onChange={onChange}
      list={list}
      defaultValue={defaultValue ?? 'all'}
      id="area-rating"
      disabled={disabled}
    />
  );
};

export default DropdownAnomalyRating;
